/* eslint-disable import/prefer-default-export */
import { message } from "antd";

export const showRequiredFieldsWarning = () => {
  message.warning("必填欄位未填");
};
